import BackofficeController from "backoffice_controller";

export default class extends BackofficeController {
  static targets = ["confirmBox", "realDeleteBtn"];

  connect() {}

  toggleDeleteConfirmBox() {
    this.confirmBoxTarget.classList.toggle("d-none");
  }

  pressRealDeleteBtn() {
    this.toggleDeleteConfirmBox();
    this.realDeleteBtnTarget.click();
  }
}
